import React from 'react';
import { 
  FaAward, 
  FaNetworkWired, 
  FaUserFriends, 
  FaHeadset,
  FaShieldAlt,
  FaRocket,
  FaChartLine,
  FaHandHoldingHeart,
  FaStar,
  FaCheckCircle
} from 'react-icons/fa';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  const advantages = [
    {
      icon: <FaAward />,
      title: 'Expertise et fiabilité',
      description: 'Plus de 5 ans d\'expérience dans l\'accompagnement des étudiants internationaux. Notre expertise est reconnue par nos partenaires et nos étudiants.',
      stats: '5+ années d\'expérience',
      color: '#073b8f'
    },
    {
      icon: <FaNetworkWired />,
      title: 'Réseau d\'écoles partenaires',
      description: 'Accès exclusif à un large réseau d\'établissements d\'enseignement supérieur en France, des grandes écoles aux universités renommées.',
      stats: '50+ établissements partenaires',
      color: '#c0264a'
    },
    {
      icon: <FaUserFriends />,
      title: 'Accompagnement personnalisé',
      description: 'Un conseiller dédié vous suit tout au long de votre projet, avec un suivi individualisé adapté à votre profil et vos objectifs.',
      stats: 'Suivi 100% personnalisé',
      color: '#073b8f'
    },
    {
      icon: <FaHeadset />,
      title: 'Suivi jusqu\'à l\'installation',
      description: 'Nous ne vous lâchons pas ! Accompagnement complet jusqu\'à votre installation en France, y compris les démarches administratives sur place.',
      stats: 'Accompagnement complet',
      color: '#c0264a'
    }
  ];

  const additionalBenefits = [
    {
      icon: <FaShieldAlt />,
      title: 'Sécurité et transparence',
      description: 'Processus clairs, coûts transparents et garantie de services conformes aux réglementations françaises.',
      color: '#073b8f'
    },
    {
      icon: <FaRocket />,
      title: 'Gain de temps optimal',
      description: 'Optimisation de toutes les démarches administratives pour un processus rapide et efficace.',
      color: '#c0264a'
    },
    {
      icon: <FaChartLine />,
      title: 'Taux de réussite élevé',
      description: '95% de nos étudiants obtiennent leur visa et intègrent l\'établissement de leur choix.',
      color: '#073b8f'
    },
    {
      icon: <FaHandHoldingHeart />,
      title: 'Support dédié 24/7',
      description: 'Une équipe à votre écoute pour répondre à toutes vos questions et préoccupations.',
      color: '#c0264a'
    }
  ];

  const successMetrics = [
    { number: '95%', label: 'Taux de réussite visa' },
    { number: '1000+', label: 'Étudiants accompagnés' },
    { number: '48h', label: 'Réponse moyenne' },
    { number: '98%', label: 'Satisfaction étudiants' }
  ];

  return (
    <section className="btg-why-choose-us-light" id="btg-why-choose">
      <div className="btg-container-light">
        {/* En-tête de section - Style clair premium */}
        <div className="btg-why-header-light">
          <div className="btg-header-content-light">
            <div className="btg-header-badge">
              <FaStar className="btg-badge-icon" />
              <span>Excellence & Confiance</span>
            </div>
            <h1 className="btg-main-title-light">Pourquoi choisir BTG CONSEIL ?</h1>
            <p className="btg-main-subtitle-light">Votre partenaire de confiance</p>
            <p className="btg-section-subtitle-light">
              Découvrez les avantages qui font de nous le partenaire de confiance 
              pour votre projet d'études en France
            </p>
            <div className="btg-header-decoration-light">
              <div className="btg-decoration-line-light"></div>
              <div className="btg-decoration-dot-light"></div>
              <div className="btg-decoration-glow-light"></div>
              <div className="btg-decoration-dot-light"></div>
              <div className="btg-decoration-line-light"></div>
            </div>
          </div>
        </div>

        {/* Métriques de succès */}
        <div className="btg-success-metrics-light">
          {successMetrics.map((metric, index) => (
            <div key={index} className="btg-metric-card-light">
              <div className="btg-metric-number-light">{metric.number}</div>
              <div className="btg-metric-label-light">{metric.label}</div>
              <div className="btg-metric-glow"></div>
            </div>
          ))}
        </div>

        {/* Avantages principaux */}
        <div className="btg-advantages-grid-light">
          {advantages.map((advantage, index) => (
            <div 
              key={index} 
              className="btg-advantage-card-light"
              style={{ '--btg-accent-color': advantage.color }}
            >
              <div className="btg-card-glow" style={{ '--glow-color': advantage.color }}></div>
              
              <div className="btg-advantage-icon-wrapper-light">
                <div className="btg-advantage-icon-light">
                  {advantage.icon}
                </div>
                <div className="btg-icon-glow"></div>
              </div>
              
              <div className="btg-advantage-content-light">
                <h3>{advantage.title}</h3>
                <p>{advantage.description}</p>
                <div className="btg-advantage-stats-light">
                  <FaCheckCircle className="btg-stat-icon" />
                  {advantage.stats}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bannière de valeur */}
        <div className="btg-value-banner-light">
          <div className="btg-value-content-light">
            <div className="btg-value-text-light">
              <h3>Notre engagement : Votre réussite</h3>
              <p>
                Chez BTG CONSEIL, nous croyons que chaque étudiant mérite une chance 
                de réussir son projet d'études à l'étranger. Notre mission va au-delà 
                des simples formalités administratives : nous vous accompagnons vers 
                une intégration réussie en France.
              </p>
            </div>
            <div className="btg-value-badge-light">
              <FaHandHoldingHeart className="btg-badge-icon" />
              <span>Engagement total</span>
            </div>
          </div>
          
          {/* Background animé */}
          <div className="btg-banner-background-light">
            <div className="btg-banner-particle"></div>
            <div className="btg-banner-particle"></div>
            <div className="btg-banner-particle"></div>
          </div>
        </div>

        {/* Avantages supplémentaires */}
        <div className="btg-additional-benefits-light">
          <div className="btg-benefits-header-light">
            <div className="btg-benefits-header-content-light">
              <h2 className="btg-benefits-main-title-light">Nos engagements supplémentaires</h2>
              <p className="btg-benefits-subtitle-light">Excellence et qualité de service</p>
              <div className="btg-benefits-header-decoration-light">
                <div className="btg-benefits-decoration-line-light"></div>
                <div className="btg-benefits-decoration-dot-light"></div>
                <div className="btg-benefits-decoration-line-light"></div>
              </div>
            </div>
          </div>
          
          <div className="btg-benefits-grid-light">
            {additionalBenefits.map((benefit, index) => (
              <div 
                key={index} 
                className="btg-benefit-card-light"
                style={{ '--btg-accent-color': benefit.color }}
              >
                <div className="btg-benefit-icon-container-light">
                  <div className="btg-benefit-icon-light">
                    {benefit.icon}
                  </div>
                  <div className="btg-icon-glow"></div>
                </div>
                <div className="btg-benefit-content-light">
                  <h4>{benefit.title}</h4>
                  <p>{benefit.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Final */}
        <div className="btg-final-cta-light">
          <div className="btg-cta-content-light">
            <div className="btg-cta-header-light">
              <h3 className="btg-cta-title-light">Prêt à démarrer votre aventure ?</h3>
              <p className="btg-cta-subtitle-light">Votre réussite commence ici</p>
            </div>
            <p className="btg-cta-text-light">
              Rejoignez les centaines d'étudiants qui nous font confiance 
              pour concrétiser leur projet d'études en France
            </p>
            <div className="btg-cta-buttons-light">
              <button className="btg-cta-primary-light">
                <FaRocket className="btg-cta-icon" />
                Commencer mon projet
                <div className="btg-button-glow"></div>
              </button>
              <button className="btg-cta-secondary-light">
                Poser une question
              </button>
            </div>
            
            <div className="btg-cta-stats-light">
              <div className="btg-stat-light">
                <div className="btg-stat-number-light">500+</div>
                <div className="btg-stat-label-light">Étudiants accompagnés</div>
              </div>
              <div className="btg-stat-light">
                <div className="btg-stat-number-light">95%</div>
                <div className="btg-stat-label-light">Taux de réussite</div>
              </div>
              <div className="btg-stat-light">
                <div className="btg-stat-number-light">98%</div>
                <div className="btg-stat-label-light">Satisfaction</div>
              </div>
            </div>
          </div>
          
          {/* Background animé */}
          <div className="btg-cta-background-light">
            <div className="btg-cta-particle"></div>
            <div className="btg-cta-particle"></div>
            <div className="btg-cta-particle"></div>
          </div>
        </div>
      </div>

      {/* Background éléments décoratifs */}
      <div className="btg-background-elements">
        <div className="btg-bg-element btg-bg-1"></div>
        <div className="btg-bg-element btg-bg-2"></div>
        <div className="btg-bg-element btg-bg-3"></div>
        <div className="btg-bg-element btg-bg-4"></div>
      </div>
    </section>
  );
};

export default WhyChooseUs;